import {
  Notification_Category,
  Notification_ReadState,
} from '@wavingroup/iot-core/gen/ts/wavin/blaze/v1/notification_pb';
import { blazeDevicePromiseClient } from '~/services/blaze-device-client';

interface SetNotificationReadStateForUserBulkParams {
  readState: Notification_ReadState;
  categoryFilter?: Notification_Category;
  filterDeviceName?: string;
}

export const setNotificationReadStateForUserBulk = async ({
  readState,
  categoryFilter = Notification_Category.UNSPECIFIED,
  filterDeviceName = '',
}: SetNotificationReadStateForUserBulkParams) =>
  await blazeDevicePromiseClient.setNotificationReadStateForUserBulk({
    readState,
    categoryFilter,
    filterDeviceName,
  });
